import { t } from 'i18next';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import DebouncedSearchBox from '~components/Search/DebouncedSearchBox';
import { useStores } from '~store';
import { SettlementSearchParamName } from '~store/SettlementsStore';

export default function SettlementsSearch() {
  const { settlementsStore } = useStores();
  const [searchParams, setSearchParams] = useSearchParams();

  const initialSearchValue = useMemo(() => {
    return searchParams.get('search') ?? '';
  }, [searchParams.get('search')]);

  const handleSearchChange = useCallback(
    (searchQuery: string) => {
      settlementsStore.setSearchParams({
        ...settlementsStore.searchParams,
        [SettlementSearchParamName.SEARCH_QUERY]: searchQuery || undefined,
      });

      // Sync search query with URL
      setSearchParams(
        (prevParams) => {
          const newParams = new URLSearchParams(prevParams);
          if (searchQuery) {
            newParams.set('search', searchQuery);
          } else {
            newParams.delete('search');
          }
          return newParams;
        },
        { replace: true },
      );
    },
    [settlementsStore, setSearchParams],
  );

  return (
    <DebouncedSearchBox
      initialValue={initialSearchValue}
      onChange={handleSearchChange}
      placeholder={`${t('form_fields.search')}`}
    />
  );
}
